import { render, staticRenderFns } from "./HomeDigiDownload.vue?vue&type=template&id=22a451dc&scoped=true&"
import script from "./HomeDigiDownload.vue?vue&type=script&lang=js&"
export * from "./HomeDigiDownload.vue?vue&type=script&lang=js&"
import style0 from "./HomeDigiDownload.vue?vue&type=style&index=0&id=22a451dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a451dc",
  null
  
)

export default component.exports